module.exports = __webpack_public_path__ + "img/RedBullActive.cb497aec.svg";